<script setup>
  import { computed, ref, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useFilterStore } from '@/stores/filter'

  const store = useFilterStore()
  const { activeFilters } = storeToRefs(store)
  const useDefaultActive = ref(true)

  const props = defineProps({
    filter: Object
  })

  const filterItems = computed(() => {
    return props.filter.items
  })

  const target = computed(() => {
    return props.filter.target
  })

  const isActiveFilter = (filter) => {
    if (useDefaultActive.value) {
      return filter.isDefault ? true : false
    }
    return activeFilters.value[target.value].includes(filter.id)
  }

  watch(activeFilters, () => {
    !activeFilters.value || !activeFilters.value[target.value] ?
      useDefaultActive.value = true :
      useDefaultActive.value = false
  })
</script>

<template>
  <div
    class="data-grid-filter-items ~mb-8/10"
  >
    <SwiperBase
      theme="filter"
      pagination="false"
    >
      <template v-slot:slides>
        <button
          v-for="filter in filterItems"
          class="swiper-slide ~text-sm/base text-left opacity-60 hover:opacity-100 !w-fit pb-1 border-b border-black border-opacity-0 hover:border-opacity-20"
          :key="filter.id"
          :class="isActiveFilter(filter) ? 'font-bold border-opacity-100': ''"
          @click="store.setActiveFilters(filter.id, target)"
        >
          {{ filter.label }}
        </button>
      </template>
    </SwiperBase>
  </div>
</template>

<style lang="scss" scoped>

</style>
